module.exports = __webpack_public_path__ + "img/added-service-unit-06.faf8d6e6.png";